export default "__VITE_ASSET__yBTGN4Ox__";